import { IAdresse } from '../mgs.types';

export function getAdresseAsString(adresse: IAdresse, mitStrasse = true): string {
  if (!adresse) {
    return '';
  }

  let street = '';
  if (mitStrasse && adresse.strasse) {
    street = `, ${adresse.strasse}`;
  }
  return adresse
    ? `${adresse.ikz ? adresse.ikz + '-' : ''}${adresse.plz ? adresse.plz : ''}${adresse.ort ? ' ' + adresse.ort : ''}${street}`
    : '';
}
